<template>
  <a-modal
    :confirm-loading="confirmLoading"
    :mask-closable="false"
    :open="isMfaSelectionModalVisible"
    centered
    class="otp-authentication-modal"
    footer=""
    html-type="submit"
    title="Select MFA Method"
    width="400px"
    @cancel="() => emit('closeMfaSelectionModal', true)"
  >
    <a-form
      layout="vertical"
      :model="form"
      :rules="rules"
      name="OTPSelection"
      class="user-form"
      @finish="onSubmit"
    >
      <div class="form-check">
        <div class="radio-container">
          <input
            class="form-check-input"
            type="radio"
            value="email"
            id="Email"
            v-model="form.otp_method"
            required
          />
          <label class="form-check-label" for="Email">
            <i class="bi bi-envelope email-icon"></i>
            Email
          </label>
        </div>
        <div class="radio-container">
          <input
            class="form-check-input"
            type="radio"
            value="googleAuth"
            id="GoogleAuth"
            v-model="form.otp_method"
            required
          />
          <label class="form-check-label" for="GoogleAuth">
            <i class="bi bi-qr-code qr-icon"></i>
            Authenticator App
          </label>
        </div>
        <div class="radio-container">
          <input
            class="form-check-input"
            type="radio"
            value="sms"
            id="Phone Number"
            v-model="form.otp_method"
            required
          />
          <label class="form-check-label" for="Phone Number">
            <i class="bi bi-phone mobile-icon"></i>
            SMS
          </label>
        </div>
      </div>
      <div class="buttons-w mt-4">
        <a-button type="primary" size="middle" html-type="submit" class="btn-block rounded-sm">
          Done
        </a-button>
      </div>
    </a-form>
  </a-modal>
  <div v-if="isMfaSetupModalVisible">
    <authenticator-app-setup-modal
      v-if="form.otp_method === 'googleAuth'"
      :is-mfa-setup-modal-visible="isMfaSetupModalVisible"
      :is-user-logging-in="isUserLoggingIn"
      @close-mfa-setup-modal="closeMfaSetupModal"
    />
    <sms-setup-modal
      v-else-if="form.otp_method === 'sms'"
      :is-mfa-setup-modal-visible="isMfaSetupModalVisible"
      :is-user-logging-in="isUserLoggingIn"
      @close-mfa-setup-modal="closeMfaSetupModal"
    />
  </div>
</template>

<script setup>
import { useAuthStore } from 'src/stores/auth'
import { ref, watch } from 'vue'
import { useToast } from 'vue-toastification'
import AuthenticatorAppSetupModal from './AuthenticatorAppSetupModal.vue'
import SmsSetupModal from './SmsSetupModal.vue'

const props = defineProps({
  isMfaSelectionModalVisible: Boolean,
  isUserLoggingIn: Boolean
})
const emit = defineEmits(['closeMfaSelectionModal'])

const authStore = useAuthStore()
const toast = useToast()

const form = ref({
  otp_method: ''
})
const isMfaSetupModalVisible = ref(false)
const confirmLoading = ref(false)

const rules = {
  otp_method: [
    {
      required: true,
      trigger: 'submit',
      message: 'Please select an OTP method'
    }
  ]
}

watch(
  () => props.isMfaSelectionModalVisible,
  (visible) => {
    if (visible) {
      form.value.otp_method = window.localStorage.getItem('receiveOtpOn') || 'email'
    }
  }
)

const onSubmit = async () => {
  emit('closeMfaSelectionModal', false)
  if (form.value.otp_method === window.localStorage.getItem('receiveOtpOn')) {
    toast.warning('Same method selected')
    return
  }

  if (form.value.otp_method === 'email') {
    await authStore.setOtpMethodEmail('email')
  } else {
    isMfaSetupModalVisible.value = true
  }
}

const closeMfaSetupModal = (value) => {
  isMfaSetupModalVisible.value = false
  emit('closeMfaSelectionModal', value)
}
</script>

<style scoped>
.user-form {
  width: 100%;
  margin-top: 0;
}

.radio-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;
}

.form-check-input {
  margin-right: 12px;
  cursor: pointer;
}

.email-icon,
.mobile-icon,
.qr-icon {
  font-size: 26px;
  color: #1890ff;
  margin-right: 15px;
  margin-left: 5px;
}

.form-check-label {
  font-size: 16px;
  margin: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.buttons-w {
  margin-top: 20px;
  text-align: center;
}

.btn-block {
  width: 100%;
}
</style>

<style>
.otp-authentication-modal,
.otp-authentication-modal .ant-modal-content,
.otp-authentication-modal .ant-modal-footer .ant-btn {
  overflow: hidden;
  border-radius: 10px;
}

.otp-authentication-modal .ant-modal-title {
  font-size: 20px;
}
</style>
